// FILE: src/components/admin/studentForm.js
// Rules shared by the add and edit student forms (B-26, matrix 0.6): a
// student holds an Ontario G1 or G2 with a licence number, or (owner
// decision D11, 2026-10-07) has no licence yet ("NONE", no number). The
// rules match the server (zun-lms-backend src/utils/validate.js).
import { messageFor } from "../../i18n/errors";

export const NO_LICENCE = "NONE";
export const LICENCE_CLASSES = ["G1", "G2", NO_LICENCE];
export const LICENCE_NUMBER_RE = /^[A-Z]\d{4}-?\d{5}-?\d{5}$/;
export const LICENCE_HINT = "As on the card, e.g. A1234-56789-01234";

/** A licence number is asked for only when the student holds a G1 or G2. */
export const needsLicenceNumber = (licenceClass) => licenceClass !== NO_LICENCE;

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

/** Upper case, no spaces: the form the server stores and checks. */
export function normaliseLicence(value) {
  return String(value || "")
    .toUpperCase()
    .replace(/\s+/g, "");
}

export function emailError(value) {
  const v = String(value || "").trim();
  if (!v) return "Enter the student's email address.";
  return EMAIL_RE.test(v) ? null : messageFor("INVALID_EMAIL");
}

export function licenceClassError(value) {
  return LICENCE_CLASSES.includes(value) ? null : "Choose G1, G2 or No licence yet.";
}

export function licenceNumberError(value, licenceClass) {
  const n = normaliseLicence(value);
  if (!needsLicenceNumber(licenceClass)) return n ? "Leave the licence number empty when the student has no licence yet." : null;
  if (!n) return "Enter the licence number.";
  return LICENCE_NUMBER_RE.test(n) ? null : messageFor("INVALID_LICENSE");
}

/** Which form field a server refusal is about (others go in an alert only). */
export const FIELD_FOR_CODE = {
  INVALID_EMAIL: "email",
  ALREADY_REGISTERED: "email",
  ALREADY_INVITED: "email",
  EMAIL_IN_USE: "email",
  NOT_ELIGIBLE: "licenseClass",
  INVALID_LICENSE: "licenseNumber"
};
